import BaseBlockContent from "@sanity/block-content-to-react"
import React from "react"
import RichText from "./richText"
import ImageTextSection from "./imageTextSection"
import LargeQuote from "./largeQuote"

import styles from "./pageBuilder.module.scss"

const serializers = {
  types: {
    fullwidthTextSection(props) {
      return (
        <div
          className={styles.section}
          data-align={props.node.alignment ? props.node.alignment : ""}
          data-grey-bg={!!props.node.greyBgColor}
          data-pull-bottom={!!props.node.pullBottomDown}
          data-pull-top={!!props.node.pullTopDown}
        >
          <div className="grid">
            <div className="gridItem">
              <div
                className={styles.sectionInner}
                data-reduced={props.node.reducedTxtWidth}
              >
                <RichText blocks={props.node.text} />
              </div>
            </div>
          </div>
        </div>
      )
    },
    imageTextSection(props) {
      return (
        <div
          className={styles.section}
          data-grey-bg={!!props.node.greyBgColor}
          data-pull-bottom={!!props.node.pullBottomDown}
          data-pull-top={!!props.node.pullTopDown}
        >
          <div className="grid">
            <div className="gridItem">
              <ImageTextSection {...props.node} />
            </div>
          </div>
        </div>
      )
    },
    largeQuote(props) {
      return (
        <div className={styles.blockquote}>
          <div className="grid">
            <div className="gridItem">
              <LargeQuote {...props.node} />
            </div>
          </div>
        </div>
      )
    },
  },
}

const PageBuilder = ({ blocks }) => {
  return (
    <div className={styles.pageBuilder}>
      <BaseBlockContent blocks={blocks} serializers={serializers} />
    </div>
  )
}

export default PageBuilder
